import { render } from "./TheHangCanTheThaoVH.vue?vue&type=template&id=a76d765a"
import script from "./TheHangCanTheThaoVH.vue?vue&type=script&lang=js"
export * from "./TheHangCanTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__